import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=27850d40&scoped=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=27850d40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27850d40",
  null
  
)

export default component.exports